import Backbone from 'backbone';

var GrantConsent = Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: '/gdprconsent-service/consent/grant',

    initialize: function(args) {
        this.consentTypeId = args.consentTypeId;
        this.consentLocale = args.consentLocale;
        this.consentVersion = args.consentVersion;
    }
});

export default GrantConsent;
